import { Component, ComponentFactoryResolver, ElementRef, Input, ComponentRef, ViewContainerRef, NgModule, OnChanges } from '@angular/core';

import { HtmlService } from '../../../../services/html.service';
import { DynamicComponentModule } from './dynamic-component-module';
import { SharedModule } from '../../../common/shared.module';
import { DynamicComponentService } from './../../../../services/dynamic-component.service';

@Component({
    selector: 'item-body-panel',
    template: require('./item-body-panel.component.html')
})
export class ItemBodyPanelComponent implements OnChanges {
    @Input() itemBodyPanel: PgRendererDto.ItemBodyPanel;
    @Input() interactions: PgRendererDto.InteractionDefinition[];
    html: string;
    componentRef: ComponentRef<any>;
    infoBoxVisible: boolean;
    infoBoxText: string;

    constructor(
        private componentFactoryResolver: ComponentFactoryResolver,
        private elementRef: ElementRef,
        private pgRendererHtmlService: HtmlService,
        private viewContainerRef: ViewContainerRef,
        private dynamicComponentService: DynamicComponentService
    ) { }

    ngOnChanges() {
        this.infoBoxVisible = false;
        this.infoBoxText = null;

        const el = this.elementRef.nativeElement as HTMLElement;

        if (this.componentRef) {
            const currentItemBodyPanel = this.componentRef.instance.itemBodyPanel as PgRendererDto.ItemBodyPanel;

            if (currentItemBodyPanel.CssClass.indexOf("leftpane") >= 0 && currentItemBodyPanel.Html == this.itemBodyPanel.Html) {
                return;
            }

            this.componentRef.destroy();

            //reset scroll pos
            el.parentElement.scrollTop = 0;
        }

        const bodyDiv = el.querySelector(".body");

        this.dynamicComponentService.getComponentRef(this.viewContainerRef, this.itemBodyPanel.Html)
            .then((componentRef) => {
                this.componentRef = componentRef;
                this.componentRef.instance.interactions = this.interactions;
                this.componentRef.instance.itemBodyPanel = this.itemBodyPanel;
            }).catch(reason => {
                console.log(reason);
            });
    }

}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/item-body-panel.component.ts